import { useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { landingPagePath } from '../components/navigation/paths';

export function useLogout(pathFn: () => string = landingPagePath): () => Promise<void> {
    const { logout } = useOidcAuthentication();
    return (): Promise<void> =>
        logout({
            post_logout_redirect_uri: `${window.location.origin}${pathFn()}`,
        });
}
